module.exports = __webpack_public_path__ + "static/media/NotificationIcon.ae9ee577.svg";